import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export const BlogBannerSkeleton = () => {
    return (
        <div className="container mt-5">
            <Skeleton height={400} borderRadius={30} />
        </div>
    );
}